<template>
  <!-- Wrapper -->
  <div>
    <div id="wrapper" v-if="isWrapped">
    <!-- Header -->
    <Header />

    <!-- Intro -->
    <Intro v-if="mq != 'large' " />

    <div id="main" v-if="isWrapped">
      <router-view></router-view>
    </div>

    <!-- Intro -->
    <div id="sidebar">
      <Intro v-if="mq == 'large'" />
      <!-- Footer -->
      <Footer />
    </div>
    </div>

    <!-- Single Page -->
    <div class="single" v-if="!isWrapped">
      <div id="wrapper">
      <Header />

      <div id="main">
        <router-view></router-view>
      </div>

      <Footer />

      </div>
    </div>
  </div>
</template>

<script>
import Header from "./Header.vue"
import Intro from "./Intro.vue"
import Footer from "./Footer.vue"

export default {
  computed: {
    mq() {
      return this.$mq;
    },
    isWrapped() {
      return this.$route.meta.isWrapped;
    }
  },
  components: {
    Header,
    Intro,
    Footer
  }
};
</script>